import moment from 'moment'
import React from 'react'
import Link from 'redux-first-router-link'

import ManagedAccordion from 'shared/components/ui/ManagedAccordion'
import { Loader, Menu } from 'util/ui'

import Actions from '../../../shared/LinkedResource/Actions'
import Key from '../../../shared/LinkedResource/Key'
import Row from '../../../shared/LinkedResource/Row'
import Title from '../../../shared/LinkedResource/Title'

function formatDate(date) {
  if (!date) return ''
  const displayYear = date.getFullYear() !== new Date().getFullYear()
  return moment(date).format(`D MMM${displayYear ? " 'YY" : ''}, H:mmA`)
}
export default function LinkedTrelloCard({
  card,
  card: {
    board: { name: boardName, url: boardUrl } = {},
    closed,
    createdAt,
    due,
    id,
    labels = [],
    loading,
    list: { name: listName } = {},
    name,
    members = [],
    title,
    updatedAt,
    url,
  } = {},
  onArchive,
  onSendToBoard,
  onUnlink,
  initiallyActive,
  fieldsToDisplay: {
    list: displayList,
    board: displayBoard,
    status: displayStatus,
    members: displayMembers,
    labels: displayLabels,
    created: displayCreated,
    lastUpdated: displayLastUpdated,
    dueDate: displayDueDate,
  },
}) {
  return (
    <ManagedAccordion
      as={Menu}
      collapsed
      fluid
      initiallyActive={initiallyActive}
      styled
      title={<Title>{name || title}</Title>}
      vertical
    >
      {!id && loading && <Loader active inline="centered" />}
      {card &&
        id && (
          <React.Fragment>
            <Row>
              <Key>Card: </Key>
              <Link target="_blank" to={url}>
                {name || title}
              </Link>
            </Row>
            {displayList && (
              <Row>
                <Key>List: </Key>
                {listName}
              </Row>
            )}
            {displayBoard && (
              <Row>
                <Key>Board: </Key>
                <Link target="_blank" to={boardUrl}>
                  {boardName}
                </Link>
              </Row>
            )}

            {displayStatus && (
              <Row>
                <Key>Status: </Key>
                {closed ? 'Closed' : 'Open'}
              </Row>
            )}

            {displayDueDate &&
              due && (
                <Row>
                  <Key>Due: </Key>
                  {formatDate(due)}
                </Row>
              )}
            {displayMembers &&
              members.length > 0 && (
                <Row>
                  <Key>Members: </Key>
                  {members.map(({ fullName }) => fullName).join(', ')}
                </Row>
              )}
            {displayLabels &&
              labels.length > 0 && (
                <Row>
                  <Key>Labels: </Key>
                  {labels
                    .map(({ color, name: labelName }) => labelName || color)
                    .join(', ')}
                </Row>
              )}
            {displayCreated && (
              <Row>
                <Key>Created: </Key>
                {formatDate(createdAt)}
              </Row>
            )}
            {displayLastUpdated && (
              <Row>
                <Key>Last updated: </Key>
                {formatDate(updatedAt)}
              </Row>
            )}
            <Actions
              id={id}
              actions={[
                {
                  action: onUnlink,
                  icon: 'unlink',
                  text: 'Unlink',
                },
                closed && {
                  action: onSendToBoard,
                  text: 'Send to board',
                },
                !closed && {
                  action: onArchive,
                  text: 'Archive',
                },
              ]}
            />
          </React.Fragment>
        )}
    </ManagedAccordion>
  )
}
